<template>
  <div class="table-box" v-loading="loading">
    <yx-table :data="data" :haspage="true" :page="page" @page-change="pageChange" :max-height="'300px'">
      <el-table-column prop="fileName" label="文件" min-width="220"></el-table-column>
      <el-table-column prop="campus" label="导出校区" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="statusText" label="状态"> </el-table-column>
      <el-table-column prop="createTime" label="导出时间" width="160"></el-table-column>
      <el-table-column prop="expireText" label="失效时间" width="80"></el-table-column>
      <el-table-column label="操作" width="70" align="right">
        <template #default="scope">
          <el-button type="text" @click="download(scope.row.fileUrl)"
            v-if="scope.row.isExpire === 0 && scope.row.fileUrl">下载</el-button>
        </template>
      </el-table-column>
    </yx-table>
  </div>
</template>

<script>
import {
  defineComponent, ref, inject, onUnmounted,
} from 'vue';
import { formatDatetime } from '@teacher/common-lib/filters';

export default defineComponent({
  setup() {
    const data = ref([]);
    const usePage = inject('usePage');
    const api = inject('api');
    const page = usePage();
    const loading = ref(false);
    function queryList(withLoading = false) {
      loading.value = withLoading;
      api
        .taskReportPage({ page })
        .then((res) => {
          if (res.code === 200) {
            data.value = res.data || [];
            data.value.forEach((item) => {
              const it = item;
              it.createTime = formatDatetime(it.createTime, 'yyyy-MM-dd hh:mm');
              // it.expireTime = formatDatetime(it.expireTime, 'yyyy-MM-dd hh:mm');
              it.campus = it.campusList?.map((i) => i.name).join(',') || '-';
            });
            Object.assign(page, res.page);
          }
        })
        .finally(() => {
          loading.value = false;
        });
    }
    queryList(true);
    const timer = setInterval(queryList, 20000);
    onUnmounted(() => {
      clearInterval(timer);
    });
    return {
      data,
      page,
      loading,
      queryList,
      pageChange(newPage) {
        Object.assign(page, newPage);
        queryList();
      },
      download(file) {
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = file;
        document.body.appendChild(a);
        a.click();
      },
    };
  },
});
</script>

<style lang="scss" scoped>
.table-box {
  padding: 8px 0px;
}
</style>
